// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_vn d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_v4";
export var sublinkSize = "J_v5";
export var linkSize = "J_v6";
export var Link = "J_tS z_tS z_tb z_tw";